import React, { useRef } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer_component";
import { Dropdown } from "antd";
import Draggable from "react-draggable";

// 菜单项
// 网址导航下拉菜单
const items_net_nav = [
  {
    key: "1",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/searchnav"
      >
        专利检索
      </a>
    ),
  },
  {
    key: "2",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/ainav"
      >
        人工智能
      </a>
    ),
  },
];
// 图片下拉菜单
const items_photo = [
  {
    key: "1",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/figures"
      >
        转黑白线稿
      </a>
    ),
  },
  {
    key: "2",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/xmind"
      >
        绘制流程图
      </a>
    ),
  },
  {
    key: "3",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/draw"
      >
        绘制思路图
      </a>
    ),
  },
  {
    key: "4",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/extract_word_photo"
      >
        提取word图
      </a>
    ),
  },
];
// 三维模型下拉菜单
const items_threeD = [
  {
    key: "1",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/threeDViewer"
      >
        三维模型预览
      </a>
    ),
  },
  {
    key: "2",
    label: (
      <a
        className="atagnav text-dark text-decoration-none"
        rel="noopener noreferrer"
        href="/ThreeD"
      >
        辨认六视图
      </a>
    ),
  },
];
// Layout 组件
const Layout_component = () => {
  //  创建一个 ref
  const donateRef = useRef(null);
  return (
    <>
      <div className="container">
        <header className="d-flex flex-wrap justify-content-center py-3  border-bottom">
          <a
            href="/"
            className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none"
          >
            <img
              src="/images/icon.svg"
              width="30"
              height="30"
              alt="Product Logo"
            />
          </a>

          <ul className="nav nav-pills">
            <li className="nav-itemt">
              <a href="/" className="nav-link text-dark" aria-current="page">
                首页
              </a>
            </li>
            <li className="nav-item">
              <a href="/todolist" className="nav-link text-dark">
                提醒事项
              </a>
            </li>
            <li className="nav-item">
              <a href="/write" className="nav-link text-dark">
                撰写
              </a>
            </li>
            <li className="nav-item">
              <a href="/aiwrite" className="nav-link text-dark">
                AI辅助撰写
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link text-dark">
                <Dropdown
                  placement="bottom"
                  overlayStyle={{
                    color: "purple",
                  }}
                  menu={{
                    items: items_photo,
                  }}
                >
                  <a
                    className="text-dark"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => e.preventDefault()}
                  >
                    图片
                  </a>
                </Dropdown>
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link">
                <Dropdown
                  placement="bottom"
                  overlayStyle={{
                    color: "purple",
                  }}
                  menu={{
                    items: items_threeD,
                  }}
                >
                  <a
                    className="text-dark"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => e.preventDefault()}
                  >
                    三维模型
                  </a>
                </Dropdown>
              </a>
            </li>
            <li className="nav-item">
              <a
                href="/Intelligent_attachment_component"
                className="nav-link text-dark"
              >
                附图标引
              </a>
            </li>
            <li className="nav-item">
              <a href="/check" className="nav-link text-dark">
                自检
              </a>
            </li>
            <li className="nav-item">
              <a href="/book" className="nav-link text-dark">
                审查指南
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link">
                <Dropdown
                  placement="bottom"
                  overlayStyle={{
                    color: "purple",
                  }}
                  menu={{
                    items: items_net_nav,
                  }}
                >
                  <a
                    className="text-dark text-decoration-none"
                    onClick={(e) => e.preventDefault()}
                  >
                    网址导航
                  </a>
                </Dropdown>
              </a>
            </li>
          </ul>
        </header>

        <Draggable nodeRef={donateRef}>
          <div
            ref={donateRef}
            className="z-3 position-fixed"
            style={{ width: "fit-content" }}
          >
            <img
              className="shadow-sm p-0 mb-5 bg-body-tertiary rounded"
              src="/images/donate.jpg"
              width={75}
              style={{ cursor: "grab", display: "block" }}
              draggable={false}
            />
          </div>
        </Draggable>
      </div>
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout_component;
